import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// ROUTES
import prebecarios from './routes/prebecarios'
import becarios from './routes/becarios'
import generaciones from './routes/generaciones'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      props: true,
      component: () => import('@/views/landing/Landing.vue'),
      meta: {
        requiresAuth: false,
        layout: 'full',
      },
    },
    {
      path: '/registro',
      name: 'registro',
      props: true,
      component: () => import('@/views/registro/Registro.vue'),
      meta: {
        requiresAuth: false,
        layout: 'full',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/Login.vue'),
      meta: {
        requiresAuth: false,
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        requiresAuth: false,
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    ...prebecarios,
    ...becarios,
    ...generaciones,
  ],
})

router.beforeEach((to, from, next) => {
  const auth = to.meta.requiresAuth
  const logged = !store.state.user.isAuthenticated

  if (!auth && !logged) {
    if (to.name === 'login') {
      return next({ name: 'prebecarios-list' })
    }
    if (to.name === 'home') {
      return next({ name: 'prebecarios-list' })
    }
    if (to.name === 'registro') {
      return next({ name: 'prebecarios-list' })
    }
    return next()
  }

  if (auth && logged) {
    return next({ name: 'home' })
  }
  return next()
})
export default router
